import { render, staticRenderFns } from "./hover-actions.vue?vue&type=template&id=b0793be0&"
import script from "./hover-actions.vue?vue&type=script&lang=js&"
export * from "./hover-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cristi\\Documents\\Work\\www\\tpdemo\\wp-content\\plugins\\translatepress\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('b0793be0', component.options)
    } else {
      api.reload('b0793be0', component.options)
    }
    module.hot.accept("./hover-actions.vue?vue&type=template&id=b0793be0&", function () {
      api.rerender('b0793be0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/src/js/components/hover-actions.vue"
export default component.exports